





























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Spinner } from 'vue-image-spinner2';
import _ from 'lodash';
import { Debounce } from 'vue-debounce-decorator';

@Component({
    name: 'ecommerce-detail-modal',
    components: {
        Spinner,
    },
    computed: {
        ...mapState('ecommerce', ['activeEcommerceLoading', 'activeEcommerce']),
        ...mapState('auth', ['currentUser']),
        ...mapState('products', ['cacheProducts', 'cacheProductsLoading']),
    },
})
export default class EcommerceDetailModal extends Vue {
    private currentUser!: any;
    private activeEcommerce!: any;
    private searchQuery: string = '';

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    onSaveEcommerce() {
        let activeEcommerce = { ...this.activeEcommerce };
        let productsInfo = [];

        this.activeEcommerce.products.forEach(product => {
            let productInfo = {
                id: product.id,
                id_new: product.id_new,
                ecommerce_price: product.ecommerce_price,
                name: product.name,
                regular_price: product.regular_price,
                brand: product.brand,
                slug: product.slug,
                clave_sat: product.clave_sat,
                wide: product.wide,
                long: product.long,
                tall: product.tall,
                price: product.price,
                price_list_3: product.price_list_3,
                gallery: product.gallery,
                complete_gallery: product.complete_gallery,
                qty: product.qty,
                stock: product.stock
            };
            productsInfo.push(productInfo);
        });
        activeEcommerce.products = productsInfo;
        
        this.$store.dispatch('ecommerce/postOne', {
        ecommerce: { data: activeEcommerce, vm: this },
        });
    }

    onAddProduct(parent: any) {
        parent.products.push({
            new: true,
        });
    }
    
    @Watch('searchQuery')
    @Debounce(600)
    updateProductsList(search: string) {
        if (/\s/.test(this.searchQuery)) {
            const finalSentence = this.searchQuery.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
            this.searchQuery = finalSentence;
        } else {
            this.searchQuery = this.searchQuery.toUpperCase();
        }

        if (this.searchQuery.length > 1 && this.searchQuery.trim() != '') {
            this.$store.dispatch('products/cacheAll', { search, limit: 40 });
        }
    }

    getProductUrl(id: string) {
        return `https://www.prodelec.app/#/products?search=${id}&page=1`; // redirect to app.prodelec.mx
    }

    onRemoveProduct(parent: any, index: any, product: any) {
        parent.products.splice(index, 1);
    }

    onSetProduct(product: any, parent: any, index: number) {
        if (product.stock > 0) {
            parent.products.splice(index, 1);
            parent.products.push({
                new: false,
                qty: 1,
                ...product,
            });
        } else {            
            this.$bvToast.toast('Stock insuficiente', {
                title: `No hay suficiente stock`,
                variant: 'info',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        }
    }
}
